import _ from 'underscore';
import Widget_Model from 'model/widget';
import Widget_Setting from 'model/widget_setting';
import View from 'view/base';
import View_Widget_Preview from 'view/widget_studio/widget_preview';

var Template_Preview = View.extend({
    className: 'template-preview-main',

    form_type: '',
    template: null,

    views: {
        widget: {},
        success: {},
    },

    events: {
        'click .template-preview-nav-prev': 'onPrev',
        'click .template-preview-nav-next': 'onNext',
    },

    dom_handlers: {
        onPrev: function(e) {
            var types = this.getWidgetTypes();
            var index = types.findIndex((item) => item === this.form_type);
            var form_type = index === 0 ? '' : types[index - 1];

            this.setFormType(form_type);
        },
        onNext: function(e) {
            var types = this.getWidgetTypes();
            var index = types.findIndex((item) => item === this.form_type);
            var form_type = types[index + 1];

            this.setFormType(form_type);
        },
    },

    shouldShowMenuList: function() {
        var types = this.getWidgetTypes();
        var multiple_types = types.length > 1;

        if (multiple_types || this.template.display_feedback || this.template.help_link) {
            return true;
        }

        return false;
    },

    getWidgetTypes: function() {
        var types = this.template.widget_settings.map((widget_setting) => widget_setting.widget_type);

        return types;
    },

    toggleNavButtons: function() {
        var types = this.getWidgetTypes();
        var menu_list_visible = this.shouldShowMenuList();

        var is_first = menu_list_visible ? this.form_type === '' : true;
        var is_last = this.form_type === types[types.length - 1];

        this.$el.find('.template-preview-nav-prev').prop('disabled', is_first);
        this.$el.find('.template-preview-nav-next').prop('disabled', is_last);
    },

    setTemplate: function(template) {
        if (this.views.widget.remove) {
            this.views.widget.remove();
        }

        if (this.views.success.remove) {
            this.views.success.remove();
        }

        this.template = {...template};
        this.template.display_powered_by = false;

        var widget_setting = {};

        this.template.widget_settings.forEach((item) => {
            var type = item.widget_type;

            widget_setting[type] = new Widget_Setting(item);
        });

        this.views.widget = new View_Widget_Preview({
            model         : new Widget_Model(this.template),
            model_setting : widget_setting
        });
        this.views.success = new View_Widget_Preview({
            model         : new Widget_Model(this.template),
            model_setting : widget_setting
        });

        var initial_type = this.shouldShowMenuList()
            ? ''
            : this.template.widget_settings[0].widget_type;

        this.views.widget.render().$el.appendTo(this.$el.find('.template-preview-form'));
        this.views.success.render(true).$el.appendTo(this.$el.find('.template-preview-success'));

        this.setFormType(initial_type);
    },

    setFormType: function(type) {
        this.form_type = type;

        this.views.widget.setFormType(type);

        if (type) {
            this.$el.find('.template-preview-success').show();
            this.views.success.setFormType(type, true);
        } else {
            this.$el.find('.template-preview-success').hide();
        }

        this.toggleNavButtons();
        this.updateContentSize();
    },

    updateContentSize: function() {
        const w = this.$el.find('.template-preview-body').width();

        this.$el.find('.template-preview-content').toggleClass('scrollable', w < 900);
    },

    initialize: function() {
        const handleResize = this.updateContentSize.bind(this);

        window.addEventListener('resize', handleResize);

        this.on('remove', () => {
            window.removeEventListener('resize', handleResize);
        });
    },

    render: function () {
        var content =
                '<div class="template-preview-body">' +
                    '<div class="template-preview-content">' +
                        '<div class="template-preview-inner">' +
                            '<div class="template-preview-form"></div>' +
                            '<div class="template-preview-success"></div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<button type="button" class="template-preview-nav-prev"><i class="fa-solid fa-chevron-left"></i></button>' +
                '<button type="button" class="template-preview-nav-next"><i class="fa-solid fa-chevron-right"></i></button>';

        this.$el.html(content);

        return this;
    },
});

export default Template_Preview;
